/* DRIPLORE Cart Widgets — $79-10 progress bar + Hero Upsell module
 *
 * fix-78: 抽出 JS 到独立 asset 由 layout 永远加载。
 * 原因：snippet 的 {% javascript %} 块只在 snippet 被 Liquid render 时才输出。
 * cart-summary.liquid 在 header-actions.liquid 内被包在 `{%- if cart.empty? -%}{%-
 * else -%}` 内，cart 空时不 render，导致 widget 的 IIFE 不输出到 page，listener
 * 从未注册。第一次 ATC 后 morph swap 把 widget HTML 拼进 DOM 但 inline <script>
 * 已被 HTML parser 标记不执行（DOM spec），listener 仍然 dead。
 *
 * 修复：JS 永远 load（layout 引用），listener 永远 register，querySelector 在
 * morph 后才找到 element 也 OK（cart:update 时 fire，DOM 已 swap 完）。
 */
(function () {
  if (window.__driploreCartWidgetsInit) return;
  window.__driploreCartWidgetsInit = true;

  /* ─── Shared helpers ─── */

  function fxRate() {
    var r = (window.Shopify && Shopify.currency && Shopify.currency.rate)
      ? parseFloat(Shopify.currency.rate) : 1;
    return isFinite(r) && r > 0 ? r : 1;
  }

  function fmtMoney(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var amount = Math.round(cents) / 100;
    try {
      return new Intl.NumberFormat(navigator.language || 'en-US', {
        style: 'currency', currency: cur, maximumFractionDigits: 0,
      }).format(amount);
    } catch (e) {
      return cur + ' ' + Math.round(amount);
    }
  }

  function escapeHtml(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  /* fix-82: removed fetchCart helper — no longer needed. All render paths now
     read cart state from DOM data attrs / inline JSON (server-rendered + auto-
     refreshed by morphSection). This avoids /cart.js rate-limiting / bot trigger. */

  // fix-82 v3: parse addResp.sections HTML to synthesize a cart-like resource.
  // Horizon's product-form.js #onCartUpdate falls back to fetch /cart.js when
  // event.detail.resource is null. Providing a synthesized cart makes Horizon
  // skip its own fetch, achieving true 0 /cart.js per hero ATC.
  //
  // fix-87: Horizon product-form.js #updateCartQuantityFromData line 231:
  //   cart.items.find(item => item.variant_id.toString() === ...)
  // → item 必须有 variant_id (否则 .toString() of undefined 抛 TypeError)。
  // PDP cross-sell ATC 后 product-form-component (主 PDP qty selector) 收到 cart:update
  // 触发 .find() → 之前的 synth 只有 handle 没 variant_id → crash。
  // 修复：每个 cart line (一个 cart-quantity-selector-component[data-variant-id])
  //      抽 variant_id + quantity + handle 三件套。
  function synthesizeCartFromSections(sectionsObj) {
    if (!sectionsObj) return null;
    for (var key in sectionsObj) {
      var html = sectionsObj[key];
      if (typeof html !== 'string' || html.indexOf('data-driplore-79-progress') < 0) continue;
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var prog = doc.querySelector('[data-driplore-79-progress]');
        if (!prog) continue;
        var sub = parseInt(prog.dataset.cartSubtotalCents || '0', 10);
        var cnt = parseInt(prog.dataset.cartItemCount || '0', 10);
        var items = [];
        // Per-line walk: cart-quantity-selector-component 每个 cart line 一个,
        // data-variant-id 是 variant_id, 子 input data-cart-quantity 是 qty,
        // 最近的 tr.cart-items__table-row 内的 a[href*="/products/"] 给 handle。
        doc.querySelectorAll('cart-items-component cart-quantity-selector-component[data-variant-id]').forEach(function (sel) {
          var vid = parseInt(sel.getAttribute('data-variant-id'), 10);
          if (!isFinite(vid)) return;
          var qtyInput = sel.querySelector('input[data-cart-quantity], input[name="updates[]"]');
          var qty = qtyInput
            ? parseInt(qtyInput.getAttribute('data-cart-quantity') || qtyInput.value || '1', 10)
            : 1;
          var row = sel.closest('tr.cart-items__table-row, [data-key]');
          var handle = '';
          if (row) {
            var a = row.querySelector('a[href*="/products/"]');
            if (a) {
              var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
              if (m) handle = m[1];
            }
          }
          items.push({ id: vid, variant_id: vid, key: vid + ':', quantity: qty, handle: handle });
        });
        // Fallback (cart 空时 cart-items-component template renders empty state,
        // 上面 selector 无 match): 用旧的 anchor 解析做 handle-only items[]。
        // 这种 case 下 product-form.js 不会进入 .find().toString() 路径 (cart 空时
        // cart.items 是 [],find 返回 undefined,cartQty=0,无 crash)。
        if (!items.length) {
          doc.querySelectorAll('cart-items-component a[href*="/products/"]').forEach(function (a) {
            var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
            if (m && !items.some(function (i) { return i.handle === m[1]; })) {
              items.push({ handle: m[1] });
            }
          });
        }
        return { item_count: cnt, items_subtotal_price: sub, items: items };
      } catch (e) { /* fall through */ }
    }
    return null;
  }

  /* ─── Widget 1: $79-10 progress bar (fix-51 + fix-54 + fix-82) ─── */

  function render79(el, cart) {
    // fix-82: prefer cart data from arg (event.detail.resource); fall back to
    // element's own data attrs (Liquid render-time embed) — avoids /cart.js fetch
    var itemCount, sub;
    if (cart && typeof cart.item_count === 'number') {
      itemCount = cart.item_count;
      sub = cart.items_subtotal_price || 0;
    } else {
      itemCount = parseInt(el.dataset.cartItemCount || '0', 10);
      sub = parseInt(el.dataset.cartSubtotalCents || '0', 10);
    }
    if (!itemCount) {
      el.setAttribute('hidden', '');
      return;
    }
    el.removeAttribute('hidden');

    var rate = fxRate();
    var threshShop = parseFloat(el.dataset.shopThresholdCents) || 7900;
    var discShop = parseFloat(el.dataset.shopDiscountCents) || 1000;
    var threshPres = threshShop * rate;
    var discPres = discShop * rate;
    var rem = threshPres - sub;
    var pct = Math.min(100, Math.max(0, sub * 100 / threshPres));

    var fill = el.querySelector('.driplore-79-progress__fill');
    if (fill) fill.style.width = pct + '%';

    var msg = el.querySelector('.driplore-79-progress__msg');
    if (!msg) return;
    if (rem <= 0) {
      msg.innerHTML = '✓ <strong>' + fmtMoney(discPres) + ' off locked in.</strong> Pull the trigger.';
    } else {
      msg.innerHTML = 'Add <strong>' + fmtMoney(rem) + '</strong> more to drop <strong>' + fmtMoney(discPres) + '</strong>.';
    }
  }

  function update79(cart) {
    var els = document.querySelectorAll('[data-driplore-79-progress]');
    els.forEach(function (el) { render79(el, cart); });
  }

  /* ─── Widget 2: Hero Upsell (fix-77) ─── */

  function readHeroPool() {
    var el = document.querySelector('[data-driplore-hero-pool]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function pickHeroCandidates(pool, cartHandles, count) {
    var available = pool.filter(function (p) { return cartHandles.indexOf(p.h) < 0; });
    for (var i = available.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = available[i]; available[i] = available[j]; available[j] = tmp;
    }
    return available.slice(0, count);
  }

  function renderHeroCards(container, candidates) {
    var rate = fxRate();
    container.innerHTML = candidates.map(function (p) {
      var priceShown = fmtMoney(p.p * rate);
      return '<a class="driplore-hero-upsell__card" data-hero-card href="' + escapeHtml(p.u) + '" data-vid="' + p.v + '">'
        + '<img class="driplore-hero-upsell__img" src="' + escapeHtml(p.i) + '" alt="" loading="lazy" decoding="async">'
        + '<div class="driplore-hero-upsell__meta">'
        +   '<p class="driplore-hero-upsell__title">' + escapeHtml(p.t) + '</p>'
        +   '<div class="driplore-hero-upsell__row">'
        +     '<span class="driplore-hero-upsell__price">' + priceShown + '</span>'
        +     '<button class="driplore-hero-upsell__add" type="button" aria-label="Add to cart" data-hero-add>+</button>'
        +   '</div>'
        + '</div>'
        + '</a>';
    }).join('');
  }

  // fix-81: 全局锁定所有 hero + 按钮在 ATC in-flight 期间。原 fix-77 仅 disable
  // 当前 clicked card 的 btn，但其他 cards 的 + 按钮仍可点 → 用户快速连点几个
  // card → 短时间内 N × 2 requests (/cart/add.js + /cart.js) → 触发 Shopify
  // Bot Manager / Cloudflare 人机验证。globally serialize ATC 把 max throughput
  // 限制在 ~1.5 req/sec 避免 trigger。
  var heroAddInFlight = false;

  function setHeroBtnsDisabled(disabled) {
    document.querySelectorAll('[data-hero-add]').forEach(function (b) {
      if (disabled) {
        b.disabled = true;
        b.dataset.lockedByAdd = '1';
      } else if (b.dataset.lockedByAdd === '1') {
        b.disabled = false;
        delete b.dataset.lockedByAdd;
      }
    });
  }

  // fix-87: openCartDrawerIfPresent — used by PDP cross-sell after ATC. Horizon
  // settings.auto_open_cart_drawer default false → cart-drawer-component 收到
  // cart:update 不会自动开 (auto-open attr 缺席)。PDP cross-sell 决策上下文需要
  // 开 drawer 让 user 看到 cart 增加 → call drawer.open() 显式。
  // 注意：cart hero upsell (in-drawer) 不调这个 (drawer 已经开)。
  function openCartDrawerIfPresent() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      try { drawer.open(); } catch (e) { /* swallow */ }
    }
  }

  function bindHeroAdd(container, opts) {
    opts = opts || {};
    container.querySelectorAll('[data-hero-card]').forEach(function (card) {
      var btn = card.querySelector('[data-hero-add]');
      if (!btn) return;
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (heroAddInFlight) return;  // global lock — ignore rapid multi-clicks
        var vid = parseInt(card.dataset.vid, 10);
        if (!vid) return;
        heroAddInFlight = true;
        setHeroBtnsDisabled(true);
        card.setAttribute('data-added', '');

        // Collect cart-items-component section IDs — same pattern as Horizon's
        // product-form.js so cart-items-component will morphSection() with the
        // returned HTML instead of falling back to sectionRenderer.renderSection()
        // (async re-fetch that would happen ~seconds later and revert our DOM
        // updates back to Liquid default 0%).
        var sectionIds = [];
        document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
          if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
        });
        var addUrl = '/cart/add.js';
        if (sectionIds.length) addUrl += '?sections=' + sectionIds.join(',');

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 }),
        })
          .then(function (r) { return r.json(); })
          .then(function (addResp) {
            // fix-82 v3: parse addResp.sections HTML 提取 cart 状态合成 resource。
            // Horizon product-form.js #onCartUpdate 监听 cart:update,如果 resource:null
            // 它 fallback fetch /cart.js。提供 valid resource shape 让 Horizon skip
            // 自己的 fetch → 真正 0 个 /cart.js per hero ATC。
            var synth = synthesizeCartFromSections(addResp.sections);
            var sourceId = opts.sourceId || 'hero-upsell';
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: synth,
                sourceId: sourceId,
                data: {
                  source: sourceId,
                  itemCount: synth ? synth.item_count : undefined,
                  sections: addResp.sections || {},
                },
              },
            }));
            // fix-87: PDP cross-sell — drawer 未开,需要显式 open。延迟 280ms 等
            // cart-items-component morphSection 完成 (我的 cart:update listener 是 250ms 后跑,
            // 所以 morphSection 早于这个 open)。
            if (opts.openDrawerAfterAdd) {
              setTimeout(openCartDrawerIfPresent, 280);
            }
          })
          .catch(function () {
            card.removeAttribute('data-added');
          })
          .finally(function () {
            // fix-83: cool-down 增加 500ms → 2000ms,因为 user 报告 4 次 hero ATC 在
            // ~7sec 内触发 Cloudflare 挑战。每次 hero ATC 1 个 /cart/add.js POST,
            // 4 个 POST in 7sec 是 Shopify Bot Manager 阈值。500ms cool-down 让 user
            // 可以 1 click /1.5sec → 4 clicks /6sec → 触发 challenge。改 2000ms
            // 后 1 click /3sec → 4 clicks /12sec,在 Bot Manager 阈值之下。
            setTimeout(function () {
              heroAddInFlight = false;
              setHeroBtnsDisabled(false);
            }, 2000);
          });
      });
    });
  }

  // fix-82 v2: parse rendered cart-items DOM (a[href*="/products/"]) for handles.
  // Horizon Liquid cart.items[].handle returns null in cart-summary context, so
  // inline JSON approach failed. Parsing DOM is fresh after morphSection.
  function readCartHandlesFromDOM() {
    var handles = [];
    document.querySelectorAll('cart-items-component a[href*="/products/"]').forEach(function (a) {
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (m && handles.indexOf(m[1]) < 0) handles.push(m[1]);
    });
    return handles;
  }

  function updateHero(cart) {
    var wrap = document.querySelector('[data-driplore-hero-upsell]');
    if (!wrap) return;
    var list = wrap.querySelector('[data-hero-list]');
    if (!list) return;
    var pool = readHeroPool();
    if (!pool.length) { wrap.setAttribute('hidden', ''); return; }

    // fix-82 v2: prefer cart from arg (event.detail.resource); fall back to parsing
    // cart-items DOM. handle parsing always returns array (may be empty).
    var cartHandles, itemCount;
    if (cart && Array.isArray(cart.items)) {
      cartHandles = cart.items.map(function (i) { return i.handle; }).filter(Boolean);
      itemCount = cart.item_count;
    } else {
      cartHandles = readCartHandlesFromDOM();
      itemCount = cartHandles.length;
    }
    if (!itemCount) { wrap.setAttribute('hidden', ''); return; }

    var candidates = pickHeroCandidates(pool, cartHandles, 3);
    if (!candidates.length) { wrap.setAttribute('hidden', ''); return; }
    renderHeroCards(list, candidates);
    bindHeroAdd(list);
    wrap.removeAttribute('hidden');
  }

  /* ─── Widget 3: PDP Cross-Sell "PAIR THE DROP" (fix-87) ───
     PDP-only — 在 product page main details column buy_buttons 之后渲染 3 hero SKU
     做 cross-sell。点 "+ Add" → POST /cart/add.js → dispatch cart:update → 显式开
     cart drawer (auto-open 默认 off,需 sourceId='pdp-cross-sell' + openDrawerAfterAdd
     option)。Pool 是 Liquid render-time 排除当前 product 的 12 hero,JS 随机选 3。 */

  function updatePdpCross() {
    var wrap = document.querySelector('[data-driplore-pdp-cross-sell]');
    if (!wrap) return;
    var list = wrap.querySelector('[data-pdp-cross-list]');
    if (!list) return;
    if (list.dataset.driploreRendered === '1') return; // 一次性 render (cart 状态变化不重选)
    var poolEl = document.querySelector('[data-driplore-pdp-cross-pool]');
    if (!poolEl) return;
    var pool;
    try { pool = JSON.parse(poolEl.textContent); } catch (e) { return; }
    if (!pool || !pool.length) return;

    // Shuffle copy + pick 3
    var shuffled = pool.slice();
    for (var i = shuffled.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = shuffled[i]; shuffled[i] = shuffled[j]; shuffled[j] = tmp;
    }
    var candidates = shuffled.slice(0, 3);
    if (!candidates.length) return;

    var rate = fxRate();
    list.innerHTML = candidates.map(function (p) {
      var priceShown = fmtMoney(p.p * rate);
      return '<a class="driplore-pdp-cross-sell__card" data-hero-card href="' + escapeHtml(p.u) + '" data-vid="' + p.v + '">'
        + '<img class="driplore-pdp-cross-sell__img" src="' + escapeHtml(p.i) + '" alt="" loading="lazy" decoding="async">'
        + '<div class="driplore-pdp-cross-sell__meta">'
        +   '<p class="driplore-pdp-cross-sell__title">' + escapeHtml(p.t) + '</p>'
        +   '<div class="driplore-pdp-cross-sell__row">'
        +     '<span class="driplore-pdp-cross-sell__price">' + priceShown + '</span>'
        +     '<button class="driplore-pdp-cross-sell__add" type="button" aria-label="Add to cart" data-hero-add>+</button>'
        +   '</div>'
        + '</div>'
        + '</a>';
    }).join('');
    bindHeroAdd(list, { sourceId: 'pdp-cross-sell', openDrawerAfterAdd: true });
    list.dataset.driploreRendered = '1';
    wrap.removeAttribute('hidden');
  }

  /* ─── Horizon bug fix: cart-quantity-selector-component 初次 mount 时
     updateButtonStates() 没正确 disable minus 按钮 (value=1, min=1 时仍可点)。
     Manually call updateButtonStates() on all cart-quantity-selector-component
     after cart-summary morph / dialog open / initial load to fix. ─── */

  function fixCartQtyButtons() {
    document.querySelectorAll('cart-quantity-selector-component').forEach(function (c) {
      if (typeof c.updateButtonStates === 'function') {
        try { c.updateButtonStates(); } catch (e) { /* swallow */ }
      }
    });
  }

  /* ─── Orchestrator (fix-82: prefer event resource → DOM data attrs → fetchCart) ─── */

  function updateAll(eventOrCart) {
    var cart = eventOrCart && eventOrCart.detail && eventOrCart.detail.resource;
    if (cart && typeof cart.item_count === 'number') {
      // Path 1: cart:update event 含 resource (Horizon native / my bindHeroAdd dispatch)
      update79(cart);
      updateHero(cart);
      fixCartQtyButtons();
      return;
    }
    // Path 2: no resource — render79 + updateHero internally fall back to embedded
    // data attrs / JSON (Liquid render-time, refreshed by morphSection automatically).
    // 不再主动 fetch /cart.js 避免触发 rate limit / bot manager。
    update79(null);
    updateHero(null);
    fixCartQtyButtons();
  }

  /* ─── Bind cart-drawer-component dialog:open listener ─── */
  // DialogOpenEvent 不 bubble，必须直接 addEventListener 在 cart-drawer-component 上。
  // Drawer 首次打开时 Horizon 可能 lazy-mount cart-items children / re-hydrate cart-summary
  // 导致 Liquid default fill: 0%；这里 setTimeout 250ms 等 Horizon 完成 hydration 再 render。
  function bindDrawerOpenListeners() {
    document.querySelectorAll('cart-drawer-component').forEach(function (drawer) {
      if (drawer.__driploreCartWidgetsBound) return;
      drawer.__driploreCartWidgetsBound = true;
      drawer.addEventListener('dialog:open', function () {
        setTimeout(updateAll, 250);
        forceStickyIfReasonable(drawer);
      });
      bindCartDrawerClickGuard(drawer);
    });
  }

  /* fix-96: 手机端删除 cart item 时 drawer 误关 — Horizon dialog.js `#handleClick`
   * 用 `dialog.contains(event.target)` 检测 click outside;cart row 在 click handler
   * 内 sync remove (prefersReducedMotion 或 view-transitions 不支持时) → click 冒泡到
   * cart-drawer-component 时 target 已脱离 DOM → contains 返回 false → 误判 outside →
   * closeDialog。Chromium + 默认 motion 跑 view-transitions 异步路径所以不复现,但
   * iOS Safari / reduced-motion 用户会中招。
   *
   * 修复:在 cart-drawer-component 上注册 click listener (capture 阶段拿 stable 坐标,
   * bubble 阶段 stopImmediatePropagation 截断 Horizon #handleClick)。Horizon 的
   * listener 由 showDialog 在我之后注册,所以我的 bubble listener 先 fire。坐标法
   * 不依赖 DOM 状态,detached target 也判得对。背景 (backdrop) 点击仍能正常 close
   * 因为坐标在 dialog rect 外。 */
  function bindCartDrawerClickGuard(drawer) {
    if (drawer.__driploreClickGuard) return;
    drawer.__driploreClickGuard = true;
    var clickStartedInside = null;
    // capture mousedown/touchstart 抓 stable 坐标 (此时 target 还在 DOM)
    function recordStart(x, y) {
      var dialog = drawer.querySelector('dialog');
      if (!dialog || !dialog.open) { clickStartedInside = null; return; }
      var r = dialog.getBoundingClientRect();
      clickStartedInside = (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom);
    }
    drawer.addEventListener('mousedown', function (e) { recordStart(e.clientX, e.clientY); }, true);
    drawer.addEventListener('touchstart', function (e) {
      var t = e.touches && e.touches[0]; if (!t) return;
      recordStart(t.clientX, t.clientY);
    }, true);
    // bubble 阶段拦 click:在 dialog 内 (按坐标) 就 stop,Horizon 的 outside check 不会跑
    drawer.addEventListener('click', function (e) {
      if (clickStartedInside === true) {
        e.stopImmediatePropagation();
      }
      clickStartedInside = null;
    });
  }

  // fix-85: Horizon cart-drawer.js #updateStickyState 阈值 0.5 — 当 summary > 50%
  // drawer 时 force sticky=false (整个 content scroll,items 无 internal scroll)。
  // 我们 summary 含 79off10 progress + shipping notice + totals + 2 CTA buttons →
  // 通常 ~600/900 = 0.67 > 0.5 → 永远 sticky=false → user 报告 items 区域看上去
  // small (需 scroll 整个 cart 才能看完)。
  // 修复: drawer:open 后 150ms 检查 sticky 状态,若 ratio < 0.85 (own safety net,
  // 比 Horizon 0.5 更宽松) force sticky=true → summary 固定底部 + items 有自己
  // overflow auto scroll 区 (好 UX)。Horizon 只在 dialog:open 时调
  // #updateStickyState 一次,所以我的 override 稳定不会被 flip 回来。
  function forceStickyIfReasonable(drawer) {
    setTimeout(function () {
      // fix-86: mobile (< 750px) 上 sticky=true 让 items area 被挤到 ~241px → 3 cart
      // items + hero upsell 塞不下 → user scroll 后 cart items 完全 out of view,
      // 不知道自己买了什么 (UX 大问题)。Mobile 上让 Horizon 自己决定 (sticky=false
      // → 整体 scroll, items 占大头, summary 在底部, 自然 UX)。只在 desktop force。
      if (window.innerWidth < 750) return;
      var dialog = drawer.querySelector('dialog');
      if (!dialog) return;
      var summary = dialog.querySelector('.cart-drawer__summary');
      if (!summary) return;
      var ratio = summary.clientHeight / dialog.clientHeight;
      if (dialog.getAttribute('cart-summary-sticky') === 'false' && ratio < 0.85) {
        dialog.setAttribute('cart-summary-sticky', 'true');
      }
    }, 150);
  }

  /* ─── Init: 多触发器确保 progress + hero + qty-btn 状态正确 ─── */

  function init() {
    updateAll();
    bindDrawerOpenListeners();
    updatePdpCross(); // fix-87: PDP cross-sell 一次性 render (page load 时)
    // fix-82 v2: cart-items-component web component upgrade is async, so cart-summary
    // (containing driplore-79off10-progress element) may not be in DOM at defer
    // script execution time. Multi-attempt with delays catches the element after
    // Horizon hydration. All updateAll paths read from DOM (no network) so safe.
    setTimeout(updateAll, 100);
    setTimeout(updateAll, 500);
    setTimeout(updateAll, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Horizon canonical: ThemeEvents.cartUpdate = 'cart:update'.
  // Listener fires in registration order — my listener registers BEFORE
  // cart-items-component (loaded as ES module later). So if I render synchronously,
  // cart-items-component's morphSection (called next) wipes my DOM changes back
  // to fresh Liquid-rendered HTML (fill: 0%). Defer with setTimeout to run AFTER
  // morph completes. 250ms is conservative; morphSection is synchronous so the
  // event tick + microtask flush should usually be enough but adding margin.
  document.addEventListener('cart:update', function (e) {
    setTimeout(function () { updateAll(e); }, 250);
    applyCartChangeCooldown();
  });

  /* fix-84: Horizon cart -/+/remove 按钮原本只 disable ~1 秒 (fetch 期间) 然后立即
     re-enable。user 报告快速点 -/remove 6 次仍触发 Cloudflare 挑战。加全局 cool-
     down 2 秒：每次 cart:update fire 后给所有 cart-items-component 加 `inert`
     attribute (HTML5 全 subtree 不可交互),2 秒后 remove。inert 同时禁用 -/+/remove
     按钮和 hero upsell + 按钮 (在 subtree 内),双重防护。 */
  var cartCooldownTimer = null;
  function applyCartChangeCooldown() {
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      c.setAttribute('inert', '');
      c.dataset.driploreCooldownLock = '1';
    });
    if (cartCooldownTimer) clearTimeout(cartCooldownTimer);
    cartCooldownTimer = setTimeout(function () {
      document.querySelectorAll('cart-items-component[data-driplore-cooldown-lock="1"]').forEach(function (c) {
        c.removeAttribute('inert');
        delete c.dataset.driploreCooldownLock;
      });
      cartCooldownTimer = null;
    }, 2000);
  }
})();
